import {MenuItem, Paper, TextField} from '@mui/material';
import {array, func, string} from 'prop-types';
import React from 'react';

const PropertySelector = ({properties, value, onChange, ...props}) => {
  return (
    <TextField
      component={Paper}
      elevation={0}
      select
      size="small"
      value={value}
      onChange={evt => onChange(evt.target.value)}
      disabled={properties.length === 0}
      {...props}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
    >
      <MenuItem value="">-</MenuItem>
      {properties.map(propName => (
        <MenuItem key={propName} value={propName}>
          {propName}
        </MenuItem>
      ))}
    </TextField>
  );
};

PropertySelector.propTypes = {
  properties: array,
  value: string,
  onChange: func,
};

export default PropertySelector;
